import type { LocationQuery } from 'vue-router'

/**
 * L'ultima vista di ogni lista, per la durata della scheda (OPENSPEC_FILTRI_PERSISTENTI.md).
 *
 * Le liste tengono filtri, ricerca e pagina nella query string; il menu pero'
 * porta all'indirizzo nudo, e rientrando si ripartiva da zero. Il router salva
 * qui la query di ogni lista mostrata e la rimette quando si rientra senza.
 *
 * sessionStorage puo' mancare o lanciare (finestra privata, storage bloccato):
 * senza, si torna al comportamento di prima, senza errori.
 */
const PREFIX = 'view:'

/** Parametri che non sono vista: `demoRole` sceglie il ruolo nell'ambiente demo. */
const NOT_VIEW = ['demoRole']

export function viewQuery(query: LocationQuery): LocationQuery {
  const own = { ...query }
  for (const key of NOT_VIEW) delete own[key]
  return own
}

export function rememberedView(path: string): LocationQuery | null {
  try {
    const raw = sessionStorage.getItem(PREFIX + path)
    if (!raw) return null
    const query = JSON.parse(raw)
    return query && typeof query === 'object' && Object.keys(query).length ? query : null
  } catch {
    return null
  }
}

export function rememberView(path: string, query: LocationQuery): void {
  try {
    sessionStorage.setItem(PREFIX + path, JSON.stringify(viewQuery(query)))
  } catch {
    // niente memoria: la lista funziona lo stesso
  }
}

/** Al logout: chi entra dopo sulla stessa scheda parte pulito. */
export function forgetViews(): void {
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith(PREFIX)) sessionStorage.removeItem(key)
    }
  } catch {
    // niente da dimenticare
  }
}
